// extracted by mini-css-extract-plugin
export default {"productDescription":"Vea-z","featuredDescription":"Wea-z","description":"Xea-z","more":"Yea-z","descriptionSku":"Zea-z"};